const APP_ENV = import.meta.env.VITE_APP_ENV ?? 'DEV';

/**
 * distinct_id = u_{dev|prod}_ + SHA256(user_id)[0..31].
 * DEVE ser idêntico ao computePostHogDistinctId do app mobile para que
 * app + web sejam a mesma Person no PostHog. Nunca enviar user_id em claro.
 */
export async function computePostHogDistinctId(
  userId: string,
  env: string = APP_ENV,
): Promise<string> {
  const envPrefix = env === 'PROD' ? 'prod' : 'dev';
  try {
    const bytes = new TextEncoder().encode(userId);
    const buf = await crypto.subtle.digest('SHA-256', bytes);
    const hex = Array.from(new Uint8Array(buf))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('');
    return `u_${envPrefix}_${hex.slice(0, 32)}`;
  } catch {
    return `u_${envPrefix}_${userId.slice(0, 8)}`;
  }
}
